import React from 'react';

// Header Component
const Header = () => (
  <header style={styles.header}>
    <h1>My Company</h1>
    <nav>
      <a href="#about">About Us</a>
      <a href="#services">Services</a>
      <a href="#contact">Contact</a>
    </nav>
  </header>
);

// About Component
const About = () => (
  <section id="about" style={styles.section}>
    <div style={styles.borderedBox}>
      <h2>About Us</h2>
      {/* <img src="/images/my-image.jpg" alt="Company" style={styles.image} /> */}
      <p>
        Welcome to My Company! We provide exceptional solutions tailored to your needs.
        test
      </p>
      <p>
    <t>
      While building any interface, you are faced with a dozen
      decisions every minute. At the core of every high quality
      interface, is a set of constraints that help in creating this
      level of consistency and quality.
    </t>
    <t>
      Not only do constriants help in consistent features, but they
      also make the decisions and their implementation fast.
    </t>
  </p>
    </div>
  </section>
);


// Services Component
const Services = () => (
  <section id="services" style={styles.section}>
    <h2>Our Services</h2>
    <ul style={styles.serviceList}>
      <li>Consulting</li>
      <li>Product Development</li>
      <li>Support & Maintenance</li>
    </ul>
  </section>
);


// Contact Component
const Contact = () => (
  <section id="contact" style={styles.section}>
    <h2>Contact Us</h2>
    <p>Email: contact@mycompany.com</p>
    <p>Phone: +1-234-567-890</p>
    <p>Address: 1234 Business Blvd, City, Country</p>
  </section>
);

// Footer Component
const Footer = () => (
  <footer style={styles.footer}>
    <p>&copy; 2025 My Company. All Rights Reserved.</p>
  </footer>
);

// Main App Component
const App = () => (
  <div>
    <Header />
    <About />
    <Services />
    <Contact />
    <Footer />
  </div>
);

// CSS Styles (Inline Example)
const styles = {
  header: {
    backgroundColor: '#333',
    color: '#fff',
    padding: '1rem',
    textAlign: 'center',
  },
  section: {
    padding: '2rem',
    textAlign: 'center',
  },
  serviceList: {
    listStyleType: 'none', // Removes bullet points
    padding: 0,
    margin: '0 auto',
    display: 'inline-block', // Centers the list horizontally
    textAlign: 'left', // Aligns the text in the list items
  },

  borderedBox: {
    border: '2px solid #ccc', // Border color and thickness
    borderRadius: '8px',      // Rounded corners
    padding: '1rem',          // Inner spacing
    maxWidth: '1000px',        // Maximum width
    margin: '0 auto',         // Center alignment
    backgroundColor: '#f9f9f9', // Light background color
  },
  
  footer: {
    backgroundColor: '#333',
    color: '#fff',
    padding: '1rem',
    textAlign: 'center',
    marginTop: '2rem',
  },
};


export default App;
